document.addEventListener("DOMContentLoaded", function () {
  // Find all video containers on the page
  var videoBlocks = document.getElementsByClassName('video-block-block'); // Check if there are any video blocks present

  if (videoBlocks.length > 0) {
    var _loop = function _loop(i) {
      var videoBlock = videoBlocks[i]; // Current video block

      var iframeContainer = videoBlock.querySelector('.iframe-container'); // Placeholder div for the iframe

      var playButton = videoBlock.querySelector('.play-button'); // Play button element

      var preview = videoBlock.querySelector('.preview'); // Thumbnail image
      // Ensure both the play button and iframe container exist

      if (playButton && iframeContainer) {
        // Add click event listener to the play button
        playButton.addEventListener('click', function () {
          // Get the video source URL from the data attribute
          var iframeSrc = iframeContainer.getAttribute('data-src');
          var isVimeo = iframeSrc.includes('vimeo'); // Check if the video is from Vimeo

          var isYouTube = iframeSrc.includes('youtube'); // Check if the video is from YouTube
          // Create the iframe element dynamically

          var iframe = document.createElement('iframe');
          iframe.src = iframeSrc + (iframeSrc.includes('?') ? '&' : '?') + "autoplay=1"; // Append autoplay parameter

          iframe.width = "100%"; // Set iframe width

          iframe.height = "100%"; // Set iframe height

          iframe.setAttribute('frameborder', '0'); // Remove frame border

          iframe.setAttribute('allow', 'autoplay; encrypted-media'); // Allow autoplay and encrypted media

          iframe.setAttribute('allowfullscreen', ''); // Allow fullscreen mode
          // Insert the iframe into the container and make it visible

          iframeContainer.innerHTML = ''; // Clear existing content in the container

          iframeContainer.appendChild(iframe); // Add the new iframe to the container

          iframeContainer.classList.remove('hidden'); // Show the iframe container
          // Hide the play button and thumbnail

          playButton.classList.add('hidden'); // Hide the play button

          if (preview) {
            preview.classList.add('hidden'); // Hide the thumbnail if it exists
          } // If it's a Vimeo video, lazy-load the Vimeo player API then initialise


          if (isVimeo) {
            function initVimeoPlayer() {
              var playerVimeo = new Vimeo.Player(iframe);
              playerVimeo.on('play', function () {
                togglePlayStatus('hide');
              });
              playerVimeo.on('pause', function () {
                togglePlayStatus('show');
              });
            }

            if (typeof Vimeo === 'undefined') {
              var vimeoTag = document.createElement('script');
              vimeoTag.src = 'https://player.vimeo.com/api/player.js';
              vimeoTag.onload = initVimeoPlayer;
              document.head.appendChild(vimeoTag);
            } else {
              initVimeoPlayer();
            }
          } // If it's a YouTube video, initialize YouTube player API


          if (isYouTube) {
            // Check if YouTube API is already loaded
            if (typeof YT === 'undefined' || typeof YT.Player === 'undefined') {
              // Load the YouTube API dynamically
              var tag = document.createElement('script');
              tag.src = "https://www.youtube.com/iframe_api"; // YouTube iframe API script URL

              var firstScriptTag = document.getElementsByTagName('script')[0];
              firstScriptTag.parentNode.insertBefore(tag, firstScriptTag); // YouTube API ready callback

              window.onYouTubeIframeAPIReady = function () {
                createYouTubePlayer(iframe); // Create YouTube player once API is loaded
              };
            } else {
              // If the API is already loaded, create the player directly
              createYouTubePlayer(iframe);
            }
          } // Function to create a YouTube player


          function createYouTubePlayer(iframe) {
            var player = new YT.Player(iframe, {
              events: {
                // Listen for state changes to handle play and pause events
                'onStateChange': function onStateChange(event) {
                  if (event.data === YT.PlayerState.PLAYING) {
                    togglePlayStatus('hide'); // Hide play button and thumbnail when video is playing
                  } else if (event.data === YT.PlayerState.PAUSED || event.data === YT.PlayerState.ENDED) {
                    togglePlayStatus('show'); // Show play button and thumbnail when video is paused or ended
                  }
                }
              }
            });
          } // Function to toggle the visibility of the play button and thumbnail


          function togglePlayStatus() {
            var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'hide';

            if (mode === 'hide') {
              playButton.classList.add('hidden'); // Hide the play button

              if (preview) preview.classList.add('hidden'); // Hide the thumbnail if it exists
            } else {
              playButton.classList.remove('hidden'); // Show the play button

              if (preview) preview.classList.remove('hidden'); // Show the thumbnail if it exists
            }
          }
        });
      }
    };

    for (var i = 0; i < videoBlocks.length; i++) {
      _loop(i);
    }
  }
});